import _ from 'underscore'
import User from '@polleverywhere/core/lib/models/user'
import AuthBase from '../auth_base'
import SSOProviders from '../sso/providers/index'
import tmpl from '../templates/multi_step_login/check.hamlc'

function handleCheckError (e) {
  const error = (e.responseJSON && e.responseJSON.error) || {}

  const message = error.message ||
    'Unable to log in, please try again or contact support@polleverywhere.com'

  this.state.set('error', message)
  this.trigger('error', error, e)
}

function checkUsername (username) {
  this._usernameBeingChecked = username

  return User.check(username)
    .then((userCheck) => {
      // Use the result only if we didn't start checking another while in-flight
      if (this._usernameBeingChecked !== username) { return }
      this._usernameBeingChecked = null

      const accountFound = userCheck && userCheck.exists
      const canSignInWithSSO = userCheck && userCheck.sso && userCheck.login_labels.length
      const canSignIn = accountFound || canSignInWithSSO

      if (!canSignIn) {
        this.form.toggleError('username', 'We could not match that username to an account.')
        return
      }

      this.trigger('account:found', { username, userCheck })
    })
    .catch(handleCheckError.bind(this))
    .always(() => this.state.set('submitting', false))
}
/**
 * This component will check the existance of a username or email address
 * and, if found, return user-level information from the API.
 *
 * @event account:found Triggered after the existance check is complete, if the user was found
 *   @param {String} username Found username
 *   @param {Object} userCheck The results from the API-based user check
 */
export default class Check extends AuthBase {
  get className () { return 'component-auth__multi-step-login__check' }
  get cta () { return this.state.get('submitting') ? 'Checking …' : this.options.cta }
  get fields () {
    return ['multi-step-login-check']
  }

  get template () { return tmpl() }

  /**
   * @param {Object} options Configuration options.
   * @param {String} options.cta Override the CTA (default: Next)
   * @param {String} options.username Prefill username field
   * @param {Object} options.sso Sso configuration options - see /components/auth/sso/index for documentation
   */
  initialize (options = {}) {
    this.options = _.defaults(options, {
      cta: 'Next'
    })

    if (this.options.sso) {
      this.sso = new SSOProviders(this.options.sso)
      this.sso.on('all', this.trigger.bind(this))
      this.sso.on('error', err => {
        this.state.set('error', err.message || 'Unable to sign in, please try again')
      })
    }

    super.initialize({ username: options.username })
  }

  render () {
    super.render()

    if (this.sso) {
      this.$('.component-auth__sso-providers-container').append(this.sso.render().$el)
    }

    this.$('.component-auth__sso-providers-divider').prop('hidden', !this.sso)

    return this
  }

  handleSubmit (e) {
    if (e) { e.preventDefault() }

    if (!this.validate()) { return }
    this.state.set('submitting', true)

    let username = this.form.serialize().username
    username = username.trim ? username.trim() : username

    checkUsername.call(this, username)
  }

  remove () {
    this.sso && this.sso.remove()
    super.remove()
  }
}
